import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const ToastNotification = ({ message, type = 'success', onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [message]);

  if (!message) return null;

  const config = {
    success: {
      icon: 'CheckCircle',
      bg: 'bg-green-600',
      text: 'text-white',
    },
    error: {
      icon: 'AlertCircle',
      bg: 'bg-red-600',
      text: 'text-white',
    },
    info: {
      icon: 'Info',
      bg: 'bg-blue-600',
      text: 'text-white',
    },
  };

  const { icon, bg, text } = config?.[type] || config?.success;

  return (
    <div
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-5 py-3.5 rounded-xl shadow-2xl ${bg} ${text} text-sm font-medium transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}
      style={{ minWidth: '280px', maxWidth: '480px' }}
    >
      <Icon name={icon} size={18} className="flex-shrink-0" />
      <span className="flex-1">{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 opacity-80 hover:opacity-100 transition-opacity flex-shrink-0"
        >
          <Icon name="X" size={16} />
        </button>
      )}
    </div>
  );
};

export default ToastNotification;
